const getters = {
  currentPlaylist: state => {
    return state.playlist[state.topicID] || [];
  },
  sections: state => {
    let list = state.sections;
    if(list.suggestions && list.suggestions.trial) {
      list.suggestions.trial.items.sort((a,b) => {
        if(a.settings.order && b.settings.order) {
          return b.settings.order - a.settings.order
        }
        if(a.settings.order || b.settings.order) {
          return -1;
        }
        return 1;
      })
    }
    if(list.suggestions && list.suggestions.upgraded) {
      list.suggestions.upgraded.items.sort((a,b) => {
        if(a.settings.order && b.settings.order) {
          return b.settings.order - a.settings.order
        }
        if(a.settings.order || b.settings.order) {
          return -1;
        }
        return 1;
      })
    }
    return list;
  },
  isOpenOnboarding: state => state.onboarding
};

export default getters;
